import { useEffect, useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import useToast from 'hooks/useToast';

/** 세션이 staff(관리자) 인지 파악, 아닐 시 login 페이지로 리다이렉션 시키는 hook */
const useCheckStaff = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const toast = useToast();

	const type = sessionStorage.getItem('uplus_user_type');

	useEffect(() => {
		if (
			!location.pathname.includes('/login') &&
			type &&
			type !== '0'
			// login 페이지를 제외한 페이지에서는 Staff만 가능하도록
		) {
			toast('관리자만 접근 가능합니다.', false, true);
			navigate('/login', { replace: true });
		}
	}, [type, location]);
};

export default useCheckStaff;
